import * as React from "react";
import { useState } from "react";
import styled from "styled-components";
import axios from "react-axios";
import ProfileCard from "~/Components/library/ProfileCard";

const Content = styled.div`
  position: relative;

  &:hover {
    cursor: pointer;
  }
  /* padding-right: 60px; */
`;

const Container = styled.div`
  position: relative;
`;
const HoverContentWrapper = styled.div`
  margin-top: -10px;
`;
const HoverContent = styled.div`
  position: absolute;
  /* border: 1px solid #333; */
  padding: 10px;
  margin-top: 10px;
  /* margin-top: 2px; */
  margin-left: -4px;
  background-color: #fff;
  z-index: 10000;
  min-width: 360px;
  border-radius: 6px;
  /* box-shadow: 1px 2px 2px hsl(220deg 2% 50%), 2px 4px 4px hsl(220deg 2% 50%), 3px 6px 6px hsl(220deg 2% 50%); */
  box-shadow: 3px 2px 14px 0px rgba(0, 0, 0, 0.75);
  -webkit-box-shadow: 3px 2px 14px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 3px 2px 14px 0px rgba(0, 0, 0, 0.75);

  @media screen and (max-width: 786px) {
    display: none !important;
  }
`;

let mouseHoverEvent = null;

function onMouseEnter(delay, setHoverState) {
  mouseHoverEvent = setTimeout(() => setHoverState(true), delay);
}

function onMouseLeave(setHoverState) {
  if (mouseHoverEvent) {
    clearTimeout(mouseHoverEvent);
  }
  setHoverState(false);
}

function HoverCard({ chim_dir, type, children, delay, hoverContent }) {
  const testing = false;
  const [hovered, setHoverState] = useState(testing);
  const [profile, setProfile] = useState({});
  React.useEffect(() => {
    const fetchProfile = async () => {
      const { data = {} } = await axios.get(`https://www.dreamchimney.com/api/tracks/profile/${chim_dir}`);

      setProfile(data);
    };
    if (hovered) {
      fetchProfile();
    }
  }, [hovered, chim_dir]);
  return (
    <Container onMouseEnter={() => onMouseEnter(delay, setHoverState)} onMouseLeave={() => onMouseLeave(setHoverState)}>
      <Content>{children}</Content>
      {/* <HoverContent>{hoverContent(profile)}</HoverContent> */}
      {hovered && type === "profile" && (
        <HoverContentWrapper>
          <HoverContent>
            <ProfileCard profile={profile} />
          </HoverContent>
        </HoverContentWrapper>
      )}
    </Container>
  );
}

HoverCard.defaultProps = {
  hoverContent: () => null,
  delay: 100,
};

export default HoverCard;
